import { AccessAlarm } from "@mui/icons-material";

const AccessAlarmIcon = () => (
  <AccessAlarm />
);

export default AccessAlarmIcon;